import './App.css';
import Gallery from './Gallery';
import Navbar from './Navbar';
import Footer from "./Footer";

function App() {
  return (
    <>
    <Navbar/>
    <Gallery/>
    <Footer/>
    </>
  );
}


export default App;
